import React, { Component } from "react";
import { connect } from 'react-redux';
import { clear_states, resolve_shortlink_info, RESOLVE_SHORTLINK_INFO,redirect_to_lab_website } from '../states/action';

import store from '../states/store';
import { EncryptionService } from "../services/encryption.service";

import { Spinner, Alert, Badge,Button } from 'reactstrap';
import { isIOS, isMobileSafari } from 'react-device-detect';

import Shortlink_Authorization from "./Shortlink_Authorization";


import '../Styles/shared.css';
import axios from "axios";


export class Shortlink_operation extends Component {

    state = { Mylink: [], loading: true, failed: false, error: '', ServerStatus: false };
    //URL = 'http://192.168.1.118:8065/api';
    URL = 'http://www.webapi.pws.ir/api';

    constructor(props) {
        super(props);

        console.log('Shortlink_operation start');

        this.CheckServerAvailability = this.CheckServerAvailability.bind(this);
        this.LoadLinkInfo = this.LoadLinkInfo.bind(this);
        this.checkJWTToken = this.checkJWTToken.bind(this);

    }

    componentDidMount() {
        this.setState({ loading: true });

        this.props.dispatch(clear_states());

        this.CheckServerAvailability(true);
        //this.LoadLinkInfo();
        this.checkJWTToken();

    }

    CheckServerAvailability(FirstTimeload) {
        this.setState({ ServerStatus: true });
    }

    checkJWTToken(){

        let enc = new EncryptionService();

        let payload = {
            userName:'React',
            password:enc.encryptUsingAES256()
        }

        axios.post(this.URL + '/v1/auth/auth',payload)
        .then( (res) => {
            this.LoadLinkInfo(res.data.token);
        }).catch( (error) => {
            console.log(error);
            this.setState({ loading: false, failed: true, error: 'امکان دسترسی به سرور ابری مقدر نمی باشد. Token generation failure' });
        })

    }

    LoadLinkInfo(JWTtoken) {
        
        try {

            let localShortLink='';
            let includedOTP='';
            let linkMode =0;

           // console.log('1==>' + this.props.shortlink.toString());

            if (this.props.shortlink.toString().includes('&') === true)
            {
                // In this mode we do not need to give OTP from user and route directly to lab's website
                // In fact, link and its OTP password comes from URL
                localShortLink = this.props.shortlink.toString().split('&')[0]
                includedOTP = this.props.shortlink.toString().split('&')[1]
                linkMode=1;
            }
            else
            {
                localShortLink =this.props.shortlink.toString();
                linkMode=0;
            }


            let payload = {
                headers:{
                    'authorization': 'Bearer ' + JWTtoken,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            };


            var options = {  
                method: 'GET',
                headers: {
                    'authorization': 'Bearer ' + JWTtoken,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
              }

            fetch(this.URL + '/shortLink?link=pws.ir/' + localShortLink,options)
                .then(res => {

                    if (res.ok) {
                        return res.json()
                    }
                    else if (res.status == 404 || res.status == 500) {
                        this.setState({ loading: false, failed: true, error: 'لینک صحیح نمی باشد و یا منقضی شده است' });
                    }
                    else if (res.status == 429) {
                        this.setState({ loading: false, failed: true, error: 'به علت درخواست زیاد دسترسی شما به سرور محدود شده است. لطفا چند دقیقه دیگر مجددا امتحان کنید' });
                    }
                    else {
                        throw new Error('Error in fetching data!');
                    }

                }).then(res => {
                    
                    this.setState({ loading: false, Mylink: res })
                    store.dispatch({ type: RESOLVE_SHORTLINK_INFO, payload: res })

                    if (linkMode===1){
                        //console.log('4==>' + res.int_RandomCode.toString());
                        //console.log('5==>' + btoa(res.int_RandomCode.toString()));
                        if (btoa(res.int_RandomCode.toString()).replaceAll('/','').replaceAll('+','').replaceAll('=','') === includedOTP){
                            //console.log('6==>redirect_to_lab_website');
                            this.props.dispatch(redirect_to_lab_website());
                        }
                        else
                        {
                            this.setState({ loading: false, failed: true, error: 'لینک صحیح نمی باشد. حتما مطمئن شوید که لینک را به درستی وارد کرده اید. در غیر این صورت با آزمایشگاه تماس بفرمایید' + ' ' + res.str_DirectTel });
                        }
                    }
                    

                }
                ).catch(error => {
                    //console.log(error);
                    this.setState({ loading: false, failed: true, error: '' });
                })


        } catch (error) {
            this.setState({ loading: false, failed: true, error: 'خطا در اتصال به سرور رخ داده است' });
        }


    }

    


    render() {

        let content = this.state.loading ?
            (

                <div>
                    <Alert color="info">
                        <Spinner className="content-text-center" color="primary" />
                        <p className="content-text-center text-muted">در حال اتصال به سرور</p>
                    </Alert>
                </div>
            )
            :
            (
                this.state.failed ?
                    (
                        <div>
                            <Alert color="danger">
                                <p className="content-text-center"> {this.state.error ? this.state.error : 'متاسفانه در حال حاضر سرور قادر به پاسخگویی نمی باشد'}</p>
                            </Alert>
                        </div>
                    )
                    :
                    (
                        <div>
                            <Shortlink_Authorization Mylink={this.state.Mylink}></Shortlink_Authorization>
                        </div>
                    )
            )


        let SafariIncompatibleWarning = (isIOS && isMobileSafari) ?
            (
                <div className="mt-2 content-center content-text-center">
                    <Badge className="content-center" color="danger">مرورگر سافاری پشتیبانی نمی شود لطفا از یکی از مرورگرهای زیر استفاده نمایید</Badge>
                    <div className="mt-1 content-text-center">
                        <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank"><img className="img-fluid rounded-circle border Incompatible-Warning-logo content-center" src='./Assets/firefox.png' alt="Firefox" ></img></a>
                        <a href="https://www.google.com/intl/en_uk/chrome/" target="_blank"><img className="img-fluid rounded-circle border Incompatible-Warning-logo content-center" src='./Assets/chrome.png' alt="Chrome"></img></a>
                    </div>
                </div>
            )
            :
            (
                null
            )


        return (
            <div>

                {content}

                {SafariIncompatibleWarning}

            </div>
        )
    }

}


const mapStateToProps = state => {
    const Mylink = state.Mylink;
    const UserAuthPass = state.UserAuthPass;
    return { Mylink, UserAuthPass }
};

export default connect(mapStateToProps)(Shortlink_operation)